import type { FlowSlotDto } from '@/types/dtos/flows/response/flow.dto';

/** Title string for placeholders / headers when rendering slot-assets details for a slot. */
export function getSlotAssetsDetailsTitle(slot: FlowSlotDto): string {
  if (slot.contentType === 'Session' && slot.content && typeof slot.content === 'object') {
    return slot.content.title ?? '';
  }
  return slot.title ?? '';
}
